import { extraType } from "../simulation/types"

export type Message = {
  cell: string
  eventId: string | number
  title: string
  description: string
  date: string
  elapsedTime: string
  response: string
  action: number
  messageType: string
  validateResponse: string
  id: number
  type: string
  currentDate: string
  categoryId: number | null
  showResponse?: boolean
  planId?: number
  decisionId?: number
  reasonIds?: number[]
  icon?: string
  mode?: string
  checked?: boolean
  order?: number
}

export type MessagesWithExtraType = Message & Partial<extraType>

export enum MessageTypes {
  INCOMING = "Incoming Message",
  DECISION = "Decision Made",
  FACT_CHECK = "Fact Check",
  INFO_SEARCH = "Information Search",
  PLAN = "Plan Created",
  PLAN_EXECUTED = "Plan Executed", // used to add a message when a plan is executed
}

export const MessageColors = {
  [MessageTypes.INCOMING]: "bg-gray-100",
  [MessageTypes.DECISION]: "bg-lightblue",
  [MessageTypes.PLAN_EXECUTED]: "bg-lightblue",
  [MessageTypes.FACT_CHECK]: "bg-green-light-100",
  [MessageTypes.INFO_SEARCH]: "bg-yellow-100",
  [MessageTypes.PLAN]: "bg-orange-pastel",
}

export const MessageTypeIdentifiers = {
  [MessageTypes.FACT_CHECK]: "message",
}
